export default __webpack_public_path__ + "static/media/Beyond The Shadow.5e5c2692.png";